import { render, staticRenderFns } from "./DistributionConfig.vue?vue&type=template&id=cba9bcf2"
import script from "./DistributionConfig.vue?vue&type=script&lang=js"
export * from "./DistributionConfig.vue?vue&type=script&lang=js"
import style0 from "./DistributionConfig.vue?vue&type=style&index=0&id=cba9bcf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports